var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form__group" },
    [
      _c("label", { staticClass: "form__label" }, [_vm._v("Opportunity Type")]),
      _vm._v(" "),
      _c("multiselect", {
        attrs: {
          options: _vm.options,
          label: "label",
          "track-by": "value",
          "show-labels": false,
        },
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _vm._v(" "),
      this.selected || (this.selected && this.selected.length > 0)
        ? _c(
            "a",
            {
              staticClass: "form__clear",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.clearValue.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n            Clear\n        ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }